import React from "react";

const Footer = () => {
  return (
    <div style={{ marginBottom: 10, textAlign: "center" }}>
      Made with love by{" "}
      <a
        href="https://www.github.com/JunDevHarsh"
        style={{ cursor: "pointer" }}
      >
        Harsh
      </a>
    </div>
  );
};

export default Footer;
